// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"126":"9ddbd959","722":"9e962f7a","771":"f18fbffe","804":"1b8ae680"}[chunkId] + ".chunk.css");